'use es6';
/**
 * Flag enum of Design Asset Categories.
 */

export const NONE = 0;
export const BLOG = 1;
export const EMAIL = 2;
export const PAGE = 4;
export const SYSTEM = 8;